<template lang="pug">
b-form-group
  label.samtek-label Tipo de Cliente
  .tipo-cliente-cards
    .tipo-card(
      v-for="opt in radioOptions"
      :key="opt.value"
      :class="{ active: model === opt.value, disabled: disabled }"
      @click="!disabled && (model = opt.value)"
    )
      b-icon(:icon="opt.icon" font-scale="1.3")
      span {{ opt.text }}
</template>

<script>
import * as cts from '@/components/OT/constants'

export default {
  props: {
    value: Number,
    disabled: Boolean,
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  created() {
    this.radioOptions = [
      { text: 'Persona', value: cts.CLIENTE_PERSONA, icon: 'person' },
      { text: 'Retail', value: cts.CLIENTE_EMPRESA, icon: 'shop' },
    ]
  },
}
</script>

<style lang="scss" scoped>
.samtek-label {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #23201C;
  display: block;
  margin-bottom: 8px;
}

.tipo-cliente-cards {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.tipo-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 36px;
  border: 1px solid #525252;
  border-radius: 8px;
  background-color: rgba(82, 82, 82, 0.35);
  cursor: pointer;
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  color: #525252;
  transition: all 0.15s ease;
  user-select: none;

  &.active {
    border-color: #FECE2F;
    background-color: rgba(254, 206, 47, 0.3);
    color: #23201C;
    font-weight: 700;
  }

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:not(.disabled):not(.active):hover {
    border-color: #23201C;
    color: #23201C;
  }
}
</style>
